<template>
  <div>
    <div v-if="user">
      <v-navigation-drawer app right floating clipped>
        <div class="pa-8 py-6">
          <div class="d-flex flex-column align-center mb-4">
            <a id="profile-picture-trigger">
              <v-avatar color="grey" size="100" class="logo">
                <img
                  v-if="user.profilePicture"
                  :src="user.profilePicture"
                  :alt="user.username"
                />
                <v-icon v-else dark x-large>mdi-account</v-icon>
              </v-avatar>
            </a>
          </div>

          <p class="title-1 font-weight-bold">{{ getName() }}</p>
          <div class="d-flex flex-row flex-wrap">
            <p class="caption">{{ user.email1 }}</p>
            <v-icon small class="pl-1" @click="updateEmail">mdi-pencil</v-icon>
          </div>
          <p class="caption">{{ user.contactNumber1 }}</p>

          <v-divider class="my-8"></v-divider>

          <div class="d-flex flex-row">
            <v-icon small>mdi-cake</v-icon>
            <p class="mb-0 ml-2 caption">Birthday</p>
          </div>
          <p class="subtitle-1 font-weight-bold">
            {{ getParsedDate(user.birthday) }}
          </p>

          <div class="d-flex flex-row mt-4">
            <v-icon small>mdi-account-question</v-icon>
            <p class="mb-0 ml-2 caption">User Type</p>
          </div>
          <p class="subtitle-1 font-weight-bold">{{ user.userType }}</p>

          <div class="d-flex flex-row mt-4">
            <v-icon small>mdi-calendar</v-icon>
            <p class="mb-0 ml-2 caption">Date Created</p>
          </div>
          <p class="subtitle-1 font-weight-bold">
            {{ getParsedDate(user.dateCreated) }}
          </p>

          <div class="d-flex flex-row mt-4">
            <v-icon small>mdi-garage-alert</v-icon>
            <p class="mb-0 ml-2 caption">Unit Limit</p>
          </div>
          <p class="subtitle-1 font-weight-bold">{{ user.unitLimit }}</p>

          <div class="d-flex flex-row mt-4">
            <v-icon small>mdi-garage-alert</v-icon>
            <p class="mb-0 ml-2 caption">Property Limit</p>
          </div>
          <p class="subtitle-1 font-weight-bold">
            {{ user.propertyLimit }}
          </p>
        </div>

        <template v-slot:append>
          <v-btn
            class="ma-5 font-weight-bold"
            color="primary"
            text
            :disabled="!access.update"
            @click="updateAccount"
            ><v-icon class="mr-1">mdi-square-edit-outline</v-icon>Update
            Account</v-btn
          >
        </template>
      </v-navigation-drawer>

      <v-container class="mx-12 my-6">
        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-account-multiple</v-icon>
          <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
            Emergency Contacts
          </p>
        </div>
        <v-card class="card-content mb-8 pa-6" elevation="0">
          <div
            v-for="(contact, index) in user.emergencyContacts"
            :key="index + '-item'"
          >
            <v-list-item dense three-line>
              <v-list-item-avatar color="grey">
                <v-icon dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  ><p class="body-2 font-weight-bold">
                    {{ contact.name }}
                  </p></v-list-item-title
                >
                <v-list-item-subtitle
                  ><p class="caption font-weight-regular">
                    {{ contact.email }}
                  </p></v-list-item-subtitle
                >
                <v-list-item-action-text
                  ><p class="caption">
                    {{ contact.contactNumber }}
                  </p></v-list-item-action-text
                >
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-card>
      </v-container>
    </div>
    <UpdateAccount ref="updateAccount"></UpdateAccount>
    <UpdateEmail ref="updateEmail"></UpdateEmail>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <avatar-cropper
      trigger="#profile-picture-trigger"
      :upload-handler="profilePictureUploadHandler"
      :labels="cropperLabels"
    />
  </div>
</template>

<script>
import { dayjs } from '../util/date'
import AvatarCropper from 'vue-avatar-cropper'
import UpdateAccount from '../components/account/UpdateAccount.vue'
import UpdateEmail from '../components/account/UpdateEmail.vue'

export default {
  components: {
    AvatarCropper,
    UpdateAccount,
    UpdateEmail
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      cropperLabels: {
        submit: 'Submit',
        cancel: 'Cancel'
      },
      snackbar: false,
      snackbarText: '',
      loading: true
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/getUser']
    },
    access() {
      return this.$root.$roleAccess('account').access
    }
  },
  async mounted() {
    await this.$store.dispatch('auth/fetchCurrentUserAction')
    this.loading = false
  },
  methods: {
    getName() {
      let firstName = this.user.firstName ? this.user.firstName : ''
      let lastName = this.user.lastName ? this.user.lastName : ''

      if (!firstName || !lastName) return this.user.username

      return `${firstName} ${lastName}`
    },
    profilePictureUploadHandler(cropper) {
      this.loading = true
      cropper.getCroppedCanvas().toBlob(async (blob) => {
        try {
          await this.$store.dispatch('users/updateUserProfilePictureAction', {
            profilePicture: blob
          })

          // this.$router.go()
          this.loading = false
          window.location.reload()
        } catch (err) {
          this.loading = false
          this.snackbarText = err
          this.snackbar = true
        }
      })
    },
    getParsedDate(date) {
      if (date) {
        return dayjs(date).format('MMMM DD, YYYY')
      }
      return ''
    },
    updateAccount() {
      this.$refs.updateAccount.open(this.user)
    },
    updateEmail() {
      this.$refs.updateEmail.open(this.user)
    }
  }
}
</script>

<style scoped>
.v-card.card-content {
  border-radius: 12px !important;
}
.v-menu__content {
  border-radius: 20px !important;
}
.v-input {
  border-radius: 10px;
}
table tbody tr td {
  /*border: none !important;
    border-bottom: none !important;*/
  border-color: #eeeeee !important;
}
p {
  margin-bottom: 0;
}
</style>
